import { useAccount, useReadContract } from 'wagmi';
import { parseEther, formatEther } from 'viem';
import BigNumber from 'bignumber.js';
import { formatDistance } from 'date-fns';
import { CONTRACT_ADDRESSES } from 'src/constants';
import StakingABI from './abi/Staking';

export function useAssetsToSharesRatio() {
  const { data, isLoading, error } = useReadContract({
    abi: StakingABI,
    address: CONTRACT_ADDRESSES.staking,
    functionName: 'convertToShares',
    args: [parseEther('1')],
  });

  const assetsToSharesRatio = BigNumber(String(1))
    .times(String(data || 1e18))
    .div(1e18)
    .toFixed();
  const sharesToAssetsRatio = BigNumber(1).div(assetsToSharesRatio).toFixed();

  return {
    assetsToSharesRatio,
    sharesToAssetsRatio,
    isLoadingRatio: isLoading,
    ratioError: error,
  };
}

export function useSharesBalance() {
  const { address } = useAccount();

  const {
    data = BigInt(0),
    isLoading,
    error,
  } = useReadContract({
    abi: StakingABI,
    address: CONTRACT_ADDRESSES.staking,
    functionName: 'balanceOf',
    args: [address || '0x'],
    query: {
      enabled: !!address,
    },
  });

  return {
    sharesBalance: data,
    sharesBalanceFormatted: formatEther(data),
    isLoadingSharesBalance: isLoading,
    sharesBalanceError: error,
  };
}

export function useWithdrawalWaitTime() {
  const {
    data = BigInt(0),
    isLoading,
    error,
  } = useReadContract({
    abi: StakingABI,
    address: CONTRACT_ADDRESSES.staking,
    functionName: 'withdrawalWaitTime',
  });

  const waitTime = BigNumber(String(data)).times(1000);
  const now = Date.now();

  return {
    withdrawalWaitTime: waitTime,
    withdrawalWaitTimeHR: formatDistance(
      now,
      BigNumber(now).plus(waitTime).toNumber()
    ),
    isLoadingWithdrawalWaitTime: isLoading,
    withdrawalWaitTimeError: error,
  };
}

export function useStakingIsPaused() {
  const {
    data = false,
    isLoading,
    error,
  } = useReadContract({
    abi: StakingABI,
    address: CONTRACT_ADDRESSES.staking,
    functionName: 'paused',
  });

  return {
    stakingIsPaused: data,
    stakingIsPausedMessage: 'Contract is temporarily paused',
    isLoadingStakingIsPaused: isLoading,
    stakingIsPausedError: error,
  };
}
